export const MAX_ACH_IMPORT_FILE_SIZE_BYTES = 25 * 1024 * 1024; // 25 MB
export const MAX_CSV_IMPORT_FILE_SIZE_BYTES = 2 * 1024 * 1024; // 2 MB

export const NACHA_EXTENSIONS = [".nacha", ".ach", ".txt"];
export const CSV_EXTENSIONS = [".csv"];
export const ALLOWED_EXTENSIONS = [
  ...NACHA_EXTENSIONS,
  ...CSV_EXTENSIONS,
];
